import { useContext, useEffect, useState } from "react";
import loggerStyle from "../../commandLogger.module.css";

import { AuthContext } from "../../../../../../contexts/AuthContext";
import { PentestContext } from "../../../../../../contexts/PentestContext";
import { apiTokenRetrieve } from "../../../../../../sdk";
import CopyBlock from "../../../../../Common/CopyBlock/CopyBlock";
import InfoHover from "../../../../../Common/Tooltips/InformationHover/InformationHover";
import { LoggerContext } from "../../../../../../contexts/LoggerContext";
import axios from "axios";
import { TutorialContext } from "../../../../../../contexts/TutorialContext";

async function fetchPentestToken(token: string, pentestId: number) {
  try {
    const response = await apiTokenRetrieve(token, pentestId);
    console.log(response.data);
    return response.data.token;
  } catch (error) {
    if (!axios.isAxiosError(error)) {
      return "";
    }
    console.log("ERROR FETCHING TOKEN:", error.response);
    return "";
  }
}

function TokenWidget() {
  const token = useContext(AuthContext).token;
  const pentestId = useContext(PentestContext).pentestId;

  const [pentestToken, setPentestToken] = useState("");
  const { tutorialRefs } = useContext(TutorialContext);

  const { tokenDisplay } = useContext(LoggerContext);

  useEffect(() => {
    const loadData = async () => {
      if (token && pentestId != -1) {
        setPentestToken(await fetchPentestToken(token, pentestId));
      }
    };

    loadData();
  }, [pentestId, token]);

  if (!tokenDisplay) return;

  return (
    <div className={loggerStyle.tokenBox} ref={tutorialRefs.tokenBoxRef}>
      <div className={loggerStyle.tokenHeader}>
        <h3>Token</h3>
        <div>
          <InfoHover description="Your Pentest token. Paste it in the terminal to start syncing commands." />
        </div>
      </div>
      <CopyBlock text={pentestToken || "Token is unavailable for viewers"} />
    </div>
  );
}

export default TokenWidget;
